import React from 'react';
import { Edit, SimpleForm, TextInput } from 'react-admin';

export const ContentTypeEdit = () => (
    <Edit title="Edit content type" actions={false} redirect="list">
      <SimpleForm>
        <TextInput source="name" label="Name" required />
        <TextInput source="display_name" label="Display Name" required />
        <TextInput source="description" label="Description" />
      </SimpleForm>
    </Edit>
);

